<script>
    import classnames from 'clsx';

    const {
        class: className,
        color = 'primary',
        disabled,
        labels,
        ...otherProps
    } = $props();

    const colorClasses = {
        primary: 'peer-focus:ring-primary-300 peer-checked:bg-primary-600',
        secondary: 'peer-focus:ring-secondary-300 peer-checked:bg-secondary-600',
        red: 'peer-focus:ring-red-300 peer-checked:bg-red-600',
        green: 'peer-focus:ring-green-300 peer-checked:bg-green-600',
        purple: 'peer-focus:ring-purple-300 peer-checked:bg-purple-600',
        teal: 'peer-focus:ring-teal-300 peer-checked:bg-teal-600',
        yellow: 'peer-focus:ring-yellow-300 peer-checked:bg-yellow-600',
        orange: 'peer-focus:ring-orange-300 peer-checked:bg-orange-600',
        blue: 'peer-focus:ring-blue-300 peer-checked:bg-blue-600'
    };
</script>

<label class="inline-flex items-center cursor-pointer">
    {#if labels}
        <span class="me-3 text-sm font-medium text-gray-900">
            {labels.false}
        </span>
    {/if}

    <input type="checkbox"
           class="sr-only peer"
           disabled={disabled}
           {...otherProps}/>
    <!-- Double quotes: Tailwind reads the source as is, an escaped quote inside an arbitrary value is never generated -->
    <div class={classnames("relative shrink-0 w-11 h-6 bg-gray-200 peer-focus:outline-hidden peer-focus:ring-4 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all", colorClasses[color], className)}></div>

    {#if labels}
        <span class="ms-3 text-sm font-medium text-gray-900">
            {labels.true}
        </span>
    {/if}
</label>
